/* ============================================
   [Fix-14] 商品ページファーストビューの再構成（SPのみ）
   株式会社ニューポート 2026-08-24

   背景：SP実測（440×956）で商品名が y=813、価格 y=904、
   カートボタン y=1,247。iPhone 14（844px）では価格もボタンも
   初期表示に入らない。

   日本の化粧品EC（ORBIS / 資生堂 / アスタリフト / ドクターシーラボ /
   DECENCIA）は5サイトとも商品名を画像より上に置いている。
   The Ordinary はモバイル専用ブロックで商品名・★・価格だけを
   画像の上に出している。それに合わせる。

   実装：商品名・英語名・★レビュー・価格・Paidy を含む
   .group-block を、SPのときだけ画像の上へ移動する。
   サイズ選択・送料・数量・カートボタンは画像の下のまま。
   PCは2カラムのままなので何もしない（幅をまたいだら元に戻す）。

   [2026-09-07 追記] LP型PDP（商品KVセクション .dl-product-hero-section を
   持つテンプレート）では、KVが既にファーストビューを担っており、
   カルーセル→商品名→価格→サイズ選択→カートの順で見せるため、
   この並べ替えは行わない。
   ============================================ */
(function () {
  var MQ = '(max-width: 749px)';

  function isPdp() { return /\/products\//.test(location.pathname); }
  function $(s) { return document.querySelector(s); }

  /* 商品KVセクションを持つLP型PDPでは、DOMのもとの順番をそのまま使う */
  function isNaturalOrderTemplate() {
    return !!$('.dl-product-hero-section');
  }

  function markTemplate() {
    document.body.classList.toggle('np-tpl-product', isPdp());
  }

  function reorder() {
    if (!isPdp()) return;
    if (isNaturalOrderTemplate()) return;
    var grid = $('.product-information__grid');
    var media = $('.product-information__media');
    var content = $('.product-details .group-block-content');
    if (!grid || !media) return;

    // 商品名・★・価格を含むブロックを探す
    var head = grid.querySelector(':scope > .np-pdp-head');
    if (!head && content) {
      head = Array.prototype.slice.call(content.children).filter(function (el) {
        return el.classList.contains('group-block') && el.querySelector('h1');
      })[0];
    }
    if (!head) return;

    var isSp = window.matchMedia(MQ).matches;

    if (isSp) {
      if (head.parentElement !== grid || head.nextElementSibling !== media) {
        head.classList.add('np-pdp-head');
        grid.insertBefore(head, media);
      }
    } else if (head.parentElement === grid && content) {
      // PCに戻ったら元の位置（.view-product-title の直後）へ
      head.classList.remove('np-pdp-head');
      var anchor = content.querySelector(':scope > .view-product-title');
      if (anchor && anchor.nextSibling) content.insertBefore(head, anchor.nextSibling);
      else content.insertBefore(head, content.firstChild);
    }
  }

  function run() {
    markTemplate();
    reorder();
  }

  var t;
  function schedule() { clearTimeout(t); t = setTimeout(run, 200); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
  try {
    var mql = window.matchMedia(MQ);
    if (mql.addEventListener) mql.addEventListener('change', run);
    else if (mql.addListener) mql.addListener(run);
  } catch (e) {}
  window.addEventListener('resize', schedule);
})();
